var _defs, _rect, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardBlackNoBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mastercard",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 350 230",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-2);}.cls-2{fill:#fff;}.cls-3{fill:url(#linear-gradient-17);}.cls-4{fill:#12100b;opacity:.78;}.cls-5{fill:url(#linear-gradient-15);}.cls-6{fill:url(#linear-gradient-18);}.cls-7{fill:#e8550d;}.cls-8{fill:#e10814;}.cls-9{fill:url(#linear-gradient-14);}.cls-10{fill:url(#linear-gradient-20);}.cls-11{fill:url(#linear-gradient-6);}.cls-12{fill:#211e1b;}.cls-13{fill:url(#linear-gradient-11);}.cls-14{fill:url(#linear-gradient-10);}.cls-15{fill:url(#linear-gradient-16);}.cls-16{fill:url(#linear-gradient-21);}.cls-17{fill:url(#linear-gradient-25);}.cls-18{fill:url(#linear-gradient-5);}.cls-19{clip-path:url(#clippath);}.cls-20{fill:none;}.cls-21{fill:url(#linear-gradient-7);}.cls-22{fill:url(#linear-gradient-24);}.cls-23{fill:url(#linear-gradient-9);}.cls-24{fill:url(#linear-gradient-22);}.cls-25{fill:url(#linear-gradient-3);}.cls-26{fill:#f39d00;}.cls-27{fill:url(#linear-gradient);}.cls-28{fill:#dbe4eb;}.cls-29{fill:url(#linear-gradient-23);}.cls-30{fill:url(#linear-gradient-19);}.cls-31{fill:url(#linear-gradient-4);}.cls-32{fill:url(#linear-gradient-8);}.cls-33{fill:url(#linear-gradient-12);}.cls-34{fill:url(#linear-gradient-13);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 0.06,
    y: 0.09,
    width: 349.88,
    height: 229.82,
    rx: 14.69,
    ry: 14.69,
    transform: "translate(350 230) rotate(-180)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1179.68,
    y1: 496.69,
    x2: -1179.6,
    y2: 496.69,
    gradientTransform: "translate(219948.25 96250.58) scale(186.43 -193.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e20076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#e84d18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7b700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 496.76,
    x2: -1179.6,
    y2: 496.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1179.68,
    y1: 496.71,
    x2: -1179.6,
    y2: 496.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -1179.68,
    y1: 496.74,
    x2: -1179.6,
    y2: 496.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -1179.68,
    y1: 496.73,
    x2: -1179.6,
    y2: 496.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -1179.68,
    y1: 496.73,
    x2: -1179.6,
    y2: 496.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    y1: 496.74,
    y2: 496.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -1179.68,
    y1: 496.73,
    x2: -1179.6,
    y2: 496.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 496.73,
    x2: -1179.6,
    y2: 496.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -1179.68,
    y1: 496.73,
    x2: -1179.6,
    y2: 496.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -1179.68,
    y1: 496.73,
    x2: -1179.6,
    y2: 496.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    y1: 496.73,
    x2: -1179.6,
    y2: 496.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -1179.68,
    y1: 496.71,
    x2: -1179.6,
    y2: 496.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -1179.68,
    y1: 496.76,
    x2: -1179.6,
    y2: 496.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -1179.68,
    y1: 496.73,
    x2: -1179.6,
    y2: 496.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -1179.68,
    y1: 496.76,
    x2: -1179.6,
    y2: 496.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    y1: 496.76,
    y2: 496.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -1179.68,
    y1: 496.73,
    x2: -1179.6,
    y2: 496.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -1179.68,
    y1: 496.68,
    x2: -1179.6,
    y2: 496.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -1179.68,
    y1: 496.71,
    x2: -1179.6,
    y2: 496.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -1179.68,
    y1: 496.71,
    x2: -1179.6,
    y2: 496.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -1179.68,
    y1: 496.7,
    x2: -1179.6,
    y2: 496.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -1179.68,
    y1: 496.72,
    x2: -1179.6,
    y2: 496.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    y1: 496.71,
    x2: -1179.6,
    y2: 496.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -1179.68,
    y1: 496.71,
    x2: -1179.6,
    y2: 496.71,
    xlinkHref: "#linear-gradient"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 0,
    y: 0,
    width: 350,
    height: 230,
    rx: 15,
    ry: 15,
    transform: "translate(350 230) rotate(-180)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    className: "cls-4",
    d: "m54.17,238.54c-29.05-.53-56.97-11.33-78.83-30.48-1.43-1.22-1.92-3.21-1.22-4.96.64-1.74,2.32-2.88,4.17-2.82.05,0,.09,0,.14,0,3.73.18,7.55.53,11.34,1.04,19.82,2.7,51.89,11.14,64.75,14.64h.03s.05-.03.07-.04c17.66-4.37,41.05-9.68,65.4-12.03,3.86-.37,7.68-.57,11.38-.61h.15c1.85.01,3.48,1.21,4.04,2.97.64,1.78.06,3.78-1.44,4.94-6.55,5.27-13.62,9.87-21.1,13.71-.16.08-.32.16-.48.24-18.07,9.21-38.13,13.81-58.41,13.39Zm77.32-32.13h0c-3.7.04-7.46.24-11.17.6-22.85,2.2-44.51,7.02-58.81,10.45,4.98,1.15,24.29,4.71,31.56,6.05,1.16.21,2.05.38,2.56.47,1.76.33,3.53.52,5.32.57,3.7.09,7.37-.74,10.68-2.42,7.29-3.75,14.18-8.23,20.57-13.36.46-.35.64-.96.44-1.51-.15-.51-.62-.86-1.16-.86h0Zm-156.85-15.06c-.62-.01-1.29-.03-2.05-.05-9.09-.33-17.25-5.03-21.82-12.58-.01-.02-1.1-1.94-1.11-1.96-4.52-7.79-8.18-16.05-10.9-24.63-2.28-7.5-1.06-15.63,3.31-22.14,4.46-6.7,11.7-11.04,19.71-11.81,4.78-.47,9.58-.65,14.37-.55,5.12.11,10.22.51,15.3,1.2,24.32,3.31,47.51,9.56,65,14.64,17.57-4.35,40.87-9.64,65.25-11.99,5.09-.49,10.21-.7,15.32-.6,4.81.09,9.61.47,14.37,1.13,10.71,1.51,19.47,9.3,22.22,19.77,0,0,0,0,.01,0,.02.05.03.09.04.14,0,.04.01.08.02.12.55,2.23.8,4.53.74,6.83,0,.13-.01.25-.02.38,0,.11-.02.22-.02.33-.05.98-.16,1.95-.32,2.92l-.02.14c-.03.19-.06.38-.1.57-.22,1.16-.52,2.29-.9,3.41,0,.01,0,.02,0,.03,0,.02,0,.03-.01.05-3.29,9.16-7.66,17.9-13.01,26.04h-.01s0,.01,0,.01c-4.85,7.38-13.19,11.77-22.31,11.74-.68,0-1.38-.01-2.06-.02-5.14-.11-10.27-.51-15.37-1.21-24.26-3.3-47.33-9.51-64.71-14.56-17.66,4.38-41.08,9.71-65.54,12.06-5.1.49-10.23.69-15.35.6Zm-1.54-30.2c-.75-.01-1.5-.02-2.22-.02-4.78.01-9.12.93-12.89,2.72-2.8,1.33-4.75,2.85-5.8,4.51-.77,1.23-1.59,3.29.21,6.91.15.26.3.53.44.79.16.29.35.63.55.97,4.05,6.69,11.27,10.86,19.31,11.15h.49s.02.01.02.01c.49.01.99.03,1.48.04,5,.09,10.01-.1,14.99-.58,23.13-2.23,45.24-7.18,59.86-10.71-26.84-7.78-47.78-12.64-64.01-14.85-4.13-.54-8.28-.86-12.44-.94h0Zm163.86-37.15c-5-.09-9.99.1-14.97.59-23.1,2.22-45.12,7.15-59.67,10.66,14.27,4.26,41.54,11.84,63.85,14.73,2.84.35,5.7.55,8.57.59,8.9.18,21.28-.85,29.32-4.24,1.95-.83,3.47-2.45,4.16-4.46.7-1.89.55-3.99-.4-5.76l-.02-.04-.02-.04c-3.69-5.98-9.86-9.99-16.82-10.93-4.64-.64-9.32-1.01-14-1.1Zm.25-12.06h0c-5.12-.11-10.22-.51-15.29-1.21-24.31-3.31-47.51-9.56-65-14.64-17.56,4.35-40.85,9.64-65.25,11.99-5.09.49-10.21.69-15.33.6-4.81-.09-9.6-.47-14.37-1.12-10.72-1.5-19.48-9.3-22.22-19.77,0,0-.01,0-.02,0-.02-.04-.03-.09-.03-.13,0-.05-.01-.09-.02-.14-.55-2.23-.8-4.53-.74-6.83,0-.15.01-.3.02-.44,0-.09.01-.17.02-.26.05-.98.16-1.95.32-2.92.02-.12.04-.24.06-.36s.04-.23.06-.35c.22-1.16.52-2.29.9-3.41,0-.01.01-.03.01-.05,0,0,0-.02,0-.03,3.3-9.17,7.67-17.91,13.02-26.04,4.86-7.38,13.2-11.77,22.32-11.75.7,0,1.42.01,2.12.02,5.12.11,10.24.51,15.32,1.21,24.25,3.3,47.32,9.51,64.71,14.55,17.67-4.38,41.09-9.71,65.54-12.06,5.1-.49,10.23-.69,15.35-.6.61.01,1.33.03,2.05.06,9.09.33,17.25,5.03,21.82,12.57,0,.02.92,1.63,1.1,1.95,4.53,7.79,8.19,16.05,10.91,24.64,2.28,7.5,1.06,15.63-3.31,22.14-4.46,6.7-11.7,11.04-19.71,11.82-4.78.47-9.58.65-14.38.56h0ZM-21.39,78.98c-8.9-.18-21.27.84-29.31,4.23-1.96.84-3.47,2.46-4.17,4.47-.69,1.89-.55,3.98.41,5.75.02.03.03.06.05.09,3.69,5.98,9.86,9.99,16.82,10.92,4.64.64,9.32,1,14,1.09,5,.09,9.99-.1,14.97-.59,23.1-2.22,45.12-7.15,59.67-10.66-14.26-4.26-41.52-11.84-63.85-14.73-2.85-.35-5.71-.55-8.58-.59h0Zm160.05-37.66c-5-.09-10.01.1-14.99.58-23.14,2.23-45.24,7.18-59.85,10.71,26.45,7.66,47.98,12.66,64.01,14.85,4.13.55,8.3.86,12.47.95.74.01,1.48.02,2.19.02,4.77,0,9.11-.92,12.89-2.72,2.79-1.33,4.74-2.85,5.79-4.52.77-1.24,1.59-3.3-.21-6.91-.09-.16-.18-.32-.27-.48-.06-.1-.11-.2-.17-.3l-.03-.06c-.17-.31-.34-.62-.52-.92-4.05-6.69-11.28-10.85-19.32-11.14-.57-.02-1.19-.04-1.99-.05ZM-18.2,26.26c-1.85-.01-3.48-1.21-4.04-2.97-.64-1.79-.06-3.78,1.44-4.94C-14.25,13.07-7.18,8.48.3,4.63c.18-.09.36-.18.55-.27C45.79-18.5,100.09-11.72,138.01,21.49c1.43,1.21,1.92,3.21,1.21,4.95-.64,1.75-2.32,2.89-4.17,2.83-.05,0-.09,0-.14,0-3.76-.18-7.58-.54-11.34-1.05-19.86-2.7-51.9-11.13-64.75-14.63-.05.02-.07.03-.1.04-17.62,4.37-40.97,9.68-65.39,12.03-3.81.37-7.64.58-11.38.62-.05,0-.1,0-.15,0ZM12.4,4.99c-3.7-.09-7.37.74-10.68,2.42-7.29,3.75-14.18,8.22-20.57,13.36-.46.35-.64.96-.44,1.51.15.51.62.87,1.15.86,3.7-.04,7.46-.24,11.17-.6,22.84-2.19,44.5-7.01,58.8-10.45-4.99-1.15-24.32-4.72-31.6-6.06-1.15-.21-2.02-.37-2.53-.47-1.75-.33-3.53-.52-5.31-.57Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m20.24,19.61s.05,0,.08,0c-.03,0-.05,0-.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m21.56,19.67s.02,0,.03,0c0,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m25.79,20.57s.06.02.09.02c-.03,0-.06-.02-.09-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m23.04,19.91c.07.01.14.03.22.04-.07-.02-.15-.03-.22-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m22.42,19.8c.08.01.17.03.26.05-.09-.02-.17-.03-.26-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m21.81,19.7c.18.03.38.06.6.1-.2-.04-.4-.07-.6-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m22.7,19.85c.08.02.17.03.26.05-.09-.02-.17-.03-.26-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m23.51,20.01s.03,0,.05.01c-.02,0-.03,0-.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m30.12,24.12c-.07-.01-.15-.02-.23-.04.08.01.15.03.23.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m22.29,14.4s-.02,0-.03,0c.01,0,.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m22.48,14.34s0,0,0,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m29.16,23.95s-.09-.02-.14-.03c.05,0,.09.02.14.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m26.44,23.29s-.02,0-.03,0c0,0,.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m29.52,24.02c-.07-.01-.13-.03-.2-.04.07.01.14.03.2.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m29.81,24.07c-.07-.01-.14-.02-.21-.04.07.01.14.03.21.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m26.41,23.29s.02,0,.03,0c.67.18,1.6.42,2.58.63.05,0,.09.02.14.03.05.01.1.02.15.03.07.01.14.03.2.04.03,0,.06.01.09.02.07.01.14.03.21.04.03,0,.05,0,.08.01.08.01.15.03.23.04.07.01.14.02.21.03.03,0,.06,0,.09.01.2.03.4.05.59.08.2.02.4.03.6.03.12,0,.24,0,.36,0,.01,0,.03,0,.04,0,.37-.02.75-.07,1.11-.15.52-.12.86-.3.98-.51.07-.13.07-.28,0-.41-.01-.02-.02-.04-.03-.06-.3-.46-.79-.76-1.35-.83-.33-.04-.67-.06-1-.06-.36,0-.71.02-1.07.06-1.69.19-3.3.59-4.52.91.01,0,.03,0,.07.02.06.02.13.04.2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m20.38,25.21c-.85,0-1.28.14-1.5.3-.07.05-.12.11-.15.16-.1.17-.09.38.05.64.01.02.02.03.03.05.01.02.03.05.05.08,0,0,0,0,0,0,.34.51.91.83,1.53.83.05,0,.09,0,.14,0,.36,0,.71-.02,1.07-.06,1.69-.19,3.32-.59,4.54-.91-2.08-.56-3.68-.9-4.89-1.04-.29-.03-.58-.05-.87-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m31.88,18.66c1.14,0,1.53-.25,1.66-.46.08-.13.09-.28.03-.45,0-.01,0-.02-.01-.04,0-.02-.01-.03-.02-.05-.01-.03-.03-.06-.05-.09-.01-.02-.02-.04-.03-.05-.01-.02-.03-.05-.04-.07,0,0,0,0,0,0h0c-.34-.52-.91-.83-1.53-.83-.05,0-.1,0-.15,0-.36,0-.71.02-1.06.06-1.69.19-3.32.59-4.54.91,2.08.56,3.68.9,4.89,1.04.29.03.58.05.87.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m25.88,20.6s-.06-.02-.09-.02c-.59-.16-1.39-.37-2.24-.55-.02,0-.03,0-.05-.01-.08-.02-.17-.04-.25-.05-.07-.02-.15-.03-.22-.04-.02,0-.05,0-.07-.01-.09-.02-.18-.03-.26-.05,0,0-.02,0-.02,0-.09-.02-.17-.03-.26-.05,0,0,0,0,0,0-.23-.04-.42-.07-.6-.1-.08-.01-.15-.02-.22-.03,0,0-.02,0-.03,0-.11-.01-.21-.03-.31-.04-.2-.02-.4-.03-.6-.03-.11,0-.23,0-.34,0-.03,0-.05,0-.08,0-.37.02-.73.07-1.09.15,0,0,0,0,0,0-.13.03-.24.06-.35.1-.01,0-.03.01-.04.02-.04.01-.07.03-.1.04-.02,0-.03.02-.05.02-.03.01-.05.02-.08.04-.02,0-.04.02-.05.03-.02.01-.04.02-.06.04-.02.01-.04.03-.05.04-.01.01-.03.02-.04.03-.02.02-.04.04-.06.05,0,0-.02.01-.02.02-.02.03-.04.05-.06.08-.07.13-.07.29,0,.42,0,0,0,0,0,.01,0,.01.02.03.03.04.3.46.79.76,1.35.83.33.04.67.06,1,.06.36,0,.71-.02,1.07-.06,1.69-.19,3.3-.58,4.52-.91,0,0-.03,0-.06-.02-.05-.02-.11-.03-.17-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m20.8,16h.01c.26,0,.53-.03.79-.06,1.69-.19,3.31-.59,4.53-.91-.04-.01-.17-.04-.34-.09-.02,0-.05-.01-.06-.02h-.02c-.63-.17-1.78-.46-2.42-.59-.13-.03-.26-.04-.39-.04-.14,0-.28.02-.42.05,0,0,0,0,0,0-.06.01-.12.03-.18.05-.01,0-.02,0-.03,0-.05.02-.11.04-.16.07-.02,0-.03.01-.05.02-.51.27-1,.6-1.45.96-.1.08-.14.22-.09.34.04.12.16.2.29.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m31.46,27.88h-.01c-.26,0-.53.03-.79.06-1.69.19-3.31.59-4.53.91.02,0,.18.05.4.11,0,0,0,0,.01,0h0c.63.17,1.78.46,2.42.59.13.03.26.04.39.04.29,0,.57-.07.83-.2h0s0,0,.01,0c.51-.27,1-.59,1.45-.96.1-.08.14-.22.09-.34-.04-.12-.16-.2-.29-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m28.97,29.54c-.64-.13-1.81-.43-2.44-.59-.37-.09-3.27-.82-4.93-1.01-.26-.03-.53-.05-.79-.06h0c-.09,0-.18.04-.23.11-.11.13-.09.32.04.43,1.55,1.28,3.5,1.98,5.52,1.97h0c1.42,0,2.81-.34,4.06-1-.26.13-.54.2-.83.2-.13,0-.26-.01-.39-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.29,14.4c.06-.02.12-.04.18-.05,0,0,0,0,0,0,.14-.03.28-.05.42-.05.13,0,.26.01.39.04.66.14,1.89.45,2.5.61.67.17,3.31.82,4.87,1,.26.03.53.05.79.06h0c.09,0,.18-.04.23-.11.11-.13.09-.32-.04-.43-2.7-2.22-6.49-2.61-9.59-.97.01,0,.03-.01.04-.02.05-.03.1-.05.16-.07.01,0,.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m34.3,23.63h0s0,0,0,0c-.04-.15-.11-.3-.19-.43.07.13.06.28,0,.41-.24.4-1.19.62-2.09.66-.01,0-.03,0-.04,0-.12,0-.24,0-.36,0h0c-.2,0-.4,0-.6-.03-.15-.02-.35-.04-.59-.08-.03,0-.06,0-.09-.01-.07-.01-.14-.02-.21-.03-.08-.01-.15-.02-.23-.04-.03,0-.05,0-.08-.01-.07-.01-.14-.02-.21-.04-.03,0-.06-.01-.09-.02-.07-.01-.14-.03-.2-.04-.05,0-.1-.02-.15-.03-.05,0-.09-.02-.14-.03-.7-.14-1.56-.35-2.58-.63,0,0-.02,0-.03,0-.07-.02-.13-.03-.19-.05h0s-.06-.02-.07-.02c0,0,0,0,0,0,0,0,0,0,0,0-1.22-.32-2.84-.72-4.54-.91-.35-.04-.71-.06-1.06-.06-.33,0-.67.02-1,.06-.56.06-1.05.37-1.35.83-.29.45-.37,1.01-.2,1.52.2.58.47,1.14.79,1.67-.14-.25-.15-.47-.05-.64.03-.05.08-.11.15-.16.22-.16.65-.3,1.5-.3.29,0,.58.02.87.05,1.21.14,2.81.48,4.89,1.04,0,0,0,0,0,0,0,0,0,0,0,0,1.21.32,2.82.71,4.52.91.35.04.71.06,1.07.06h0s.1,0,.15,0c.62,0,1.2-.32,1.54-.83.36-.56.65-1.17.87-1.8,0,0,0,0,0,0h0c.02-.08.04-.16.06-.24,0-.02,0-.03,0-.05,0-.07.02-.13.02-.2,0,0,0-.01,0-.02,0-.01,0-.02,0-.03,0-.16-.02-.31-.06-.47,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m33.48,17.56s.03.06.05.09c0,.02.01.04.02.05,0,.01.01.02.01.04.06.18.05.33-.03.45-.13.21-.52.46-1.66.46h0c-.29,0-.58-.02-.87-.05-1.21-.14-2.81-.48-4.89-1.04,0,0,0,0,0,0,0,0,0,0,0,0-1.22-.32-2.83-.71-4.52-.91-.35-.04-.71-.06-1.07-.06-.05,0-.1,0-.15,0-.62,0-1.2.32-1.53.83-.36.56-.65,1.16-.87,1.79,0,0,0,0,0,0,0,0,0,0,0,0-.02.08-.04.15-.06.23,0,.02,0,.03,0,.05-.01.07-.02.13-.02.2,0,0,0,.01,0,.02,0,0,0,.02,0,.03,0,.16.02.31.06.47,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.04.15.11.3.19.44-.07-.13-.06-.28,0-.41.02-.03.04-.06.06-.08,0,0,.02-.01.02-.02.02-.02.04-.04.06-.05.01-.01.03-.02.04-.03.02-.01.03-.03.05-.04.02-.01.04-.02.06-.04.02,0,.03-.02.05-.03.03-.01.05-.03.08-.04.02,0,.03-.02.05-.02.03-.01.07-.03.1-.04.01,0,.03-.01.04-.02.11-.04.22-.07.35-.1,0,0,0,0,0,0,0,0,0,0,0,0,.33-.08.71-.13,1.09-.15.03,0,.05,0,.08,0,.11,0,.23,0,.34,0,.2,0,.4,0,.6.03.09,0,.19.02.31.04,0,0,.02,0,.03,0,.07,0,.15.02.22.03.2.03.4.06.6.1,0,0,0,0,0,0,.09.01.17.03.26.05,0,0,.02,0,.02,0,.09.02.17.03.26.05.02,0,.05,0,.07.01.07.01.15.03.22.04.08.02.17.03.25.05.02,0,.03,0,.05.01.63.14,1.38.32,2.24.55.03,0,.06.02.09.02.06.02.11.03.17.05.04.01.06.02.07.02,0,0,0,0,0,0,0,0,0,0,0,0,1.22.32,2.84.72,4.54.91.35.04.71.06,1.07.06h0c.33,0,.67-.02,1-.06.55-.06,1.05-.37,1.35-.83.3-.45.37-1.01.2-1.52-.2-.58-.47-1.14-.79-1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m21.59,19.67c.07,0,.15.02.22.03-.08-.01-.15-.02-.22-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m21.59,19.67c.07,0,.15.02.22.03-.08-.01-.15-.02-.22-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m26.05,20.64c-.06-.02-.11-.03-.17-.05.06.02.12.03.17.05.03,0,.05.01.06.02,0,0,0,0,0,0,0,0-.03,0-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m26.05,20.64c-.06-.02-.11-.03-.17-.05.06.02.12.03.17.05.03,0,.05.01.06.02,0,0,0,0,0,0,0,0-.03,0-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m31.01,18.61c.29.03.58.05.87.05h0c1.14,0,1.53-.25,1.66-.46.08-.13.09-.28.03-.45.06.18.05.33-.03.45-.13.21-.52.46-1.66.46-.29,0-.58-.02-.87-.05-1.21-.14-2.81-.48-4.89-1.04,0,0,0,0,0,0,2.08.56,3.68.9,4.89,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m31.01,18.61c.29.03.58.05.87.05h0c1.14,0,1.53-.25,1.66-.46.08-.13.09-.28.03-.45.06.18.05.33-.03.45-.13.21-.52.46-1.66.46-.29,0-.58-.02-.87-.05-1.21-.14-2.81-.48-4.89-1.04,0,0,0,0,0,0,2.08.56,3.68.9,4.89,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m22.41,19.8s0,0,0,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.41,19.8s0,0,0,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m19.15,19.76c.36-.08.72-.13,1.09-.15-.37.02-.75.07-1.09.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m19.15,19.76c.36-.08.72-.13,1.09-.15-.37.02-.75.07-1.09.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m21.25,19.63c.1.01.21.02.31.04-.12-.02-.22-.03-.31-.04-.2-.02-.4-.03-.6-.03-.11,0-.22,0-.34,0,.11,0,.22,0,.34,0,.2,0,.4,0,.6.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m21.25,19.63c.1.01.21.02.31.04-.12-.02-.22-.03-.31-.04-.2-.02-.4-.03-.6-.03-.11,0-.22,0-.34,0,.11,0,.22,0,.34,0,.2,0,.4,0,.6.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m22.96,19.9s.05,0,.07.01c-.02,0-.05-.01-.07-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m22.96,19.9s.05,0,.07.01c-.02,0-.05-.01-.07-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m23.55,20.02c.85.18,1.65.39,2.24.55-.86-.24-1.61-.42-2.24-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m23.55,20.02c.85.18,1.65.39,2.24.55-.86-.24-1.61-.42-2.24-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m29.89,24.09s-.05,0-.08-.01c.03,0,.05,0,.08.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m29.89,24.09s-.05,0-.08-.01c.03,0,.05,0,.08.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m22.47,14.34c-.06.01-.12.03-.18.05.06-.02.12-.04.18-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m22.47,14.34c-.06.01-.12.03-.18.05.06-.02.12-.04.18-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m22.68,19.84s.02,0,.02,0c0,0-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.68,19.84s.02,0,.02,0c0,0-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m22.1,14.47c.05-.03.1-.05.16-.07-.05.02-.11.04-.16.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m22.1,14.47c.05-.03.1-.05.16-.07-.05.02-.11.04-.16.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m22.9,14.29c-.14,0-.28.02-.42.05.14-.03.28-.05.42-.05.13,0,.26.01.39.04.63.13,1.78.42,2.42.59h.02s.04.01.06.02c-.61-.16-1.84-.47-2.5-.61-.13-.03-.26-.04-.39-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m22.9,14.29c-.14,0-.28.02-.42.05.14-.03.28-.05.42-.05.13,0,.26.01.39.04.63.13,1.78.42,2.42.59h.02s.04.01.06.02c-.61-.16-1.84-.47-2.5-.61-.13-.03-.26-.04-.39-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m23.25,19.96c.08.02.17.04.25.05-.09-.02-.17-.04-.25-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m23.25,19.96c.08.02.17.04.25.05-.09-.02-.17-.04-.25-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m29.36,29.58c-.13,0-.26-.01-.39-.04-.64-.13-1.79-.43-2.42-.59h0s0,0-.01,0c.62.16,1.8.46,2.44.59.13.03.26.04.39.04.29,0,.57-.07.83-.2h0c-.26.13-.54.2-.83.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m29.36,29.58c-.13,0-.26-.01-.39-.04-.64-.13-1.79-.43-2.42-.59h0s0,0-.01,0c.62.16,1.8.46,2.44.59.13.03.26.04.39.04.29,0,.57-.07.83-.2h0c-.26.13-.54.2-.83.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m30.33,24.16c-.07-.01-.14-.02-.21-.03.07.01.15.02.21.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m30.33,24.16c-.07-.01-.14-.02-.21-.03.07.01.15.02.21.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m29.61,24.03s-.06-.01-.09-.02c.03,0,.06.01.09.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m29.61,24.03s-.06-.01-.09-.02c.03,0,.06.01.09.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m21.25,25.26c-.29-.03-.58-.05-.87-.05-.85,0-1.29.14-1.5.3.22-.16.65-.3,1.5-.3.29,0,.58.02.87.05,1.21.14,2.81.48,4.89,1.04,0,0,0,0,0,0-2.08-.56-3.68-.9-4.89-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m21.25,25.26c-.29-.03-.58-.05-.87-.05-.85,0-1.29.14-1.5.3.22-.16.65-.3,1.5-.3.29,0,.58.02.87.05,1.21.14,2.81.48,4.89,1.04,0,0,0,0,0,0-2.08-.56-3.68-.9-4.89-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m26.21,23.23h0c.07.02.13.04.19.05-.07-.02-.14-.04-.2-.06-.03,0-.06-.02-.07-.02,0,0,0,0,0,0,0,0,.03,0,.07.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.21,23.23h0c.07.02.13.04.19.05-.07-.02-.14-.04-.2-.06-.03,0-.06-.02-.07-.02,0,0,0,0,0,0,0,0,.03,0,.07.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m29.02,23.92c-.98-.2-1.92-.44-2.58-.63,1.02.28,1.88.48,2.58.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m29.02,23.92c-.98-.2-1.92-.44-2.58-.63,1.02.28,1.88.48,2.58.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m29.31,23.98c-.05-.01-.1-.02-.15-.03.05.01.1.02.15.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m29.31,23.98c-.05-.01-.1-.02-.15-.03.05.01.1.02.15.03Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    className: "cls-2",
    d: "m66.78,29.52h-2.02v-11.1h1.65l.28.78c.69-.6,1.62-.93,2.59-.93,2.56,0,4.08,2.25,4.08,4.42s-1.53,4.42-4.1,4.42c-.91,0-1.82-.3-2.49-.83v3.23h0Zm2.23-9.4c-1.29,0-2.34,1.16-2.34,2.59s1.05,2.56,2.34,2.56,2.32-1.13,2.32-2.58-1.02-2.58-2.32-2.58Zm25.1,7c-2.55,0-4.48-1.89-4.48-4.39s1.83-4.45,4.27-4.45c2.62,0,3.99,2.16,3.99,4.3,0,.41-.05.69-.05.7l-.06.31h-6.03c.12.51.41.93.83,1.23.42.3.96.46,1.56.46.7,0,1.49-.18,2.23-.49l.35-.15.72,1.61-.32.16c-.33.17-1.53.72-3.01.72Zm-.14-7c-1.08,0-1.94.69-2.21,1.75h4.15c-.05-.34-.19-.82-.56-1.21-.35-.36-.81-.55-1.38-.55h0Zm-41.7,7c-2.49,0-4.43-1.94-4.43-4.42s1.95-4.42,4.43-4.42,4.46,1.94,4.46,4.42c0,2.48-1.96,4.42-4.46,4.42Zm0-7c-1.34,0-2.4,1.13-2.4,2.58s1.05,2.58,2.4,2.58,2.41-1.13,2.41-2.58-1.04-2.58-2.41-2.58Zm-9.07,7c-2.49,0-4.43-1.94-4.43-4.42s1.95-4.42,4.43-4.42c1.56,0,2.98.77,3.79,2.06l-1.79.88c-.44-.7-1.17-1.1-2-1.1-1.34,0-2.4,1.13-2.4,2.58s1.05,2.58,2.4,2.58c.4,0,.8-.1,1.15-.3.34-.2.63-.47.84-.8l1.8.89c-.81,1.29-2.23,2.06-3.79,2.06Zm44.24-.15h-2v-6.55l-1.04-.37v-1.63h1.04v-1.5c0-1.61,1.17-1.95,2.16-1.95h1.21v1.7h-.55c-.45,0-.81.36-.81.8v.94h1.36v1.63h-1.36v6.92h0Zm-4.93,0h-2.02v-6.55l-1.04-.37v-1.63h3.06v8.55h0Zm-3.89,0h-1.21c-.98,0-2.16-.34-2.16-1.95v-10.05h2v9.49c0,.44.36.8.81.8h.55v1.7h0Zm-17.98,0h-2.02v-8.55h1.65l.26.72c.57-.48,1.32-.72,2.23-.72h.38v1.98h-.38c-1.6,0-2.04.88-2.13,1.63v4.94h0Zm20.7-9.06c-.67,0-1.2-.53-1.2-1.2s.53-1.2,1.2-1.2,1.23.54,1.23,1.18c0,.67-.55,1.21-1.23,1.21h0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m309.91,193.75h7.48v14.96h-7.48v-14.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m309.85,201.18c0-2.98,1.4-5.62,3.55-7.32-1.58-1.24-3.57-1.99-5.75-1.99-5.15,0-9.32,4.17-9.32,9.32s4.17,9.32,9.32,9.32c2.17,0,4.17-.75,5.75-1.99-2.15-1.68-3.55-4.35-3.55-7.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m328.48,201.18c0,5.15-4.17,9.32-9.32,9.32-2.17,0-4.17-.75-5.75-1.99,2.17-1.71,3.55-4.35,3.55-7.32s-1.4-5.62-3.55-7.32c1.58-1.24,3.57-1.99,5.75-1.99,5.15,0,9.32,4.19,9.32,9.32Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBlackNoBack);
export default __webpack_public_path__ + "static/media/card_black_no_back.2cb4100f059835b3d1c87d770028bc9b.svg";
export { ForwardRef as ReactComponent };